








































import { Component, Inject, Mixins, Prop } from "vue-property-decorator";
import HasValidation from "@/mixins/HasValidation";
import { IProductConfigProviderData } from "@/models/providers/products";

@Component
export default class ProductAttributes extends Mixins(HasValidation) {
  // Inject
  @Inject({ from: "productConfigProviderData" })
  public readonly $productConfigData!: () => IProductConfigProviderData;
  // Props
  @Prop({ default: false })
  public disabled!: boolean;
  // Computed
  public get $product() {
    return this.$productConfigData();
  }
}
